module.exports = __webpack_public_path__ + "img/3.bf7f4c67.png";